import { render } from "./WhatsAppModalSidebarRight.vue?vue&type=template&id=0ba68b04&scoped=true"
import script from "./WhatsAppModalSidebarRight.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRight.vue?vue&type=script&lang=js"

import "./WhatsAppModalSidebarRight.vue?vue&type=style&index=0&id=0ba68b04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba68b04"]])

export default __exports__